import React, { useEffect, useState } from "react";
import axios from "axios";

const Features = () => {
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFeatures();
  }, []);

  const fetchFeatures = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/cards?taxonomy=features`
      );
      setFeatures(response.data);
    } catch (error) {
      console.error("Error fetching features:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="py-5 bg-light">
        <div className="container text-center">
          <div className="d-flex justify-content-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (!features.length) {
    return (
      <section className="py-5 bg-light">
        <div className="container text-center">
          <h3 className="fw-bold mb-4">Features</h3>
          <p className="text-muted">No features available at the moment.</p>
        </div>
      </section>
    );
  }

  return (
    <section className="py-5 bg-light">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold text-dark mb-3">Why Choose Us?</h2>
          <p className="lead text-muted">
            Experience the difference with our innovative learning platform
          </p>
        </div>
        <div className="row g-4">
          {features.map((feature) => (
            <div key={feature.id} className="col-xl-3 col-lg-4 col-md-6">
              <div className="card border-0 shadow-sm h-100 transition-all hover-lift">
                {feature.image && (
                  <img
                    src={feature.image}
                    className="card-img-top"
                    alt={feature.title}
                    style={{ objectFit: "cover", height: "150px" }}
                  />
                )}
                <div className="card-body p-4 text-center">
                  <div
                    className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <i className="bi bi-star-fill text-primary fs-4"></i>
                  </div>
                  {feature.title && (
                    <h5 className="card-title fw-semibold">{feature.title}</h5>
                  )}
                  {feature.description && (
                    <p className="card-text text-muted">
                      {feature.description}
                    </p>
                  )}
                  {feature.url && feature.button_text && (
                    <a
                      href={feature.url}
                      className="btn btn-outline-primary btn-sm"
                    >
                      {feature.button_text}
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}

          {/* Fill empty slots */}
          {features.length < 4 &&
            [...Array(4 - features.length)].map((_, i) => (
              <div
                key={`placeholder-${i}`}
                className="col-xl-3 col-lg-4 col-md-6"
              >
                <div className="card border-0 shadow-sm h-100 bg-white">
                  <div className="card-body p-4 d-flex align-items-center justify-content-center text-center">
                    <div>
                      <i className="bi bi-plus-circle display-6 text-muted mb-3"></i>
                      <h6 className="text-muted">New Feature Coming Soon</h6>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
